import gql from 'graphql-tag';

export const IMPRINT_PAGE_FRAGMENT = gql`
  fragment imprintPage on ImprintPageType {
    id
    title
    text
  }
`;
